module.exports = __webpack_public_path__ + "static/media/main19.158c2235.png";